import { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Icon } from '../icon'
import { mtc, TextColors } from '../../../utils/style-helpers'
import { styles } from './styles'
import { useAnalyticsTrack, Attributes } from '@/src/features/Amplitude'

interface ILinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: ReactNode
  className?: string
  color?: TextColors
  disabled?: boolean
  href: string
  iconLeft?: IconDefinition
  iconRight?: IconDefinition
  trackMessage?: string
  trackAttributes?: Attributes
  variant?: 'primary' | 'secondary' | 'noUnderline'
  newPage?: boolean
}

export const Link = ({
  children,
  className,
  color,
  disabled,
  href,
  iconLeft,
  iconRight,
  variant,
  trackMessage,
  trackAttributes,
  newPage = false,
  onClick,
  ...rest
}: ILinkProps) => {
  const track = useAnalyticsTrack()

  const handleTrack = (e: MouseEvent<HTMLAnchorElement>) => {
    if (trackMessage) track(trackMessage, trackAttributes)
    if (onClick) onClick(e)
  }
  return (
    <a
      className={mtc(styles({ disabled, color, variant }), className)}
      href={href}
      target={newPage ? '_blank' : '_self'}
      onClick={handleTrack}
      rel={newPage ? 'noopener noreferrer' : undefined}
      {...rest}
    >
      {iconLeft && (
        <Icon
          icon={iconLeft}
          className="pr-1 right-3 text-gray-500"
          color="currentColor"
        />
      )}

      {children}

      {iconRight && (
        <Icon
          icon={iconRight}
          className="pl-1 right-3 text-gray-500"
          color="currentColor"
        />
      )}
    </a>
  )
}

Link.displayName = 'Link'
